const INITIAL_VALUES = {
  Activity: { included: [], excluded: [] },
  Allocation: { included: [], excluded: [] },
  Income: { included: [], excluded: [] },
  Performance: { included: [], excluded: [] },
  Summary: { included: [], excluded: [] },
  RiskProfile: { included: [], excluded: [] },
  RmdDashboard: { included: [], excluded: [] },
  UnRealizedGainLoss: { included: [], excluded: [] },
  RealizedGainLoss: { included: [], excluded: [] },
  GainLoss: { included: [], excluded: [] },
};

export const setDefaults = widgets => {
  return Object.entries(widgets).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: value,
    };
  }, INITIAL_VALUES);
};
